import { Edit as EditIcon } from '@carbon/icons-react';
import { Menu } from 'antd';
import { MenuItemProps } from 'antd/lib/menu/MenuItem';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const MenuItem = styled(Menu.Item)`
  span {
    flex: 1;
  }
`;

export const Edit: FC<React.PropsWithChildren<MenuItemProps>> = (params) => {
  const { icon = <EditIcon size={16} />, children } = params;

  return (
    <MenuItem icon={icon} {...params}>
      {children || <FormattedMessage id="edit" />}
    </MenuItem>
  );
};
